export default __webpack_public_path__ + "static/media/bigant_mobile.195612a5.png";